import React, { useContext } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
import { ReportsContext } from "../pages/admin/reports/Reports";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { t } from "i18next";
import { BasicContext } from "../App";
import $ from "jquery";
registerLocale("pl", pl);

const PeriodFilterDates = (props) => {
    const { startDate, setStartDate, endDate, setEndDate } = useContext(ReportsContext);
    const { setAlerts } = useContext(BasicContext);
    const { filterDates } = props;

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (!startDate) {
            $("#reportStartDate").addClass("is-invalid");
            errors.push(t("error.startDateIsEmpty"));
        } else if (!endDate) {
            $("#reportEndDate").addClass("is-invalid");
            errors.push(t("error.endDateIsEmpty"));
        } else if (startDate > endDate) {
            $("#reportStartDate").addClass("is-invalid");
            $("#reportEndDate").addClass("is-invalid");
            errors.push(t("error.startDateIsGreaterThanEndDate"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([]);
            filterDates();
        }
    };

    return (
        <Form onSubmit={checkValidation} autoComplete="off">
            <Row>
                <Col xs={6} lg={5}>
                    <Form.Group>
                        <Form.Label>{t("from_")}</Form.Label>
                        <DatePicker
                            autoComplete="off"
                            selected={startDate}
                            onChange={(date) => {
                                setStartDate(date);
                                $("#reportStartDate").removeClass("is-invalid");
                            }}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            locale="pl"
                            dateFormat="yyyy-MM-dd"
                            icon={<FontAwesomeIcon icon={faCalendar} />}
                            className="mb-3 form-control"
                            placeholderText={t("choose")}
                            id="reportStartDate"
                            minDate={"2024-12-01"}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} lg={5}>
                    <Form.Group>
                        <Form.Label>{t("to")}</Form.Label>
                        <DatePicker
                            autoComplete="off"
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            locale="pl"
                            dateFormat="yyyy-MM-dd"
                            icon={<FontAwesomeIcon icon={faCalendar} />}
                            className="mb-3 form-control"
                            placeholderText={t("choose")}
                            id="reportEndDate"
                        />
                    </Form.Group>
                </Col>
                <Col xs={{ span: 6, offset: 3 }} lg={{ span: 2, offset: 0 }}>
                    <Form.Group>
                        <Form.Label className="invisible d-lg-block d-none">button label</Form.Label>
                        <Button type="submit" variant="primary" className="w-100">
                            {t("filter")}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
        </Form>
    );
};

export default PeriodFilterDates;
